/**
 * @param {import("../../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/channels/partnerships",
    },
    (router) => {
      router.push({
        id: "@api/channel.partnership@search",
        path: "",
      });

      router.push({
        id: "@api/channel.partnership@create",
        path: "",
      });

      router.group(
        {
          path: "/:channelPartnershipId",
        },
        (router) => {
          router.push({
            id: "@api/channel.partnership@show",
            path: "",
          });

          router.push({
            id: "@api/channel.partnership@update",
            path: "",
          });

          router.push({
            id: "@api/channel.partnership@delete",
            path: "",
          });
        },
      );

      router.group(
        {
          path: "/categories",
        },
        (router) => {
          router.push({
            id: "@api/channel.partnership.category@search",
            path: "",
          });

          router.group(
            {
              path: "/:channelPartnershipCategoryId",
            },
            (router) => {
              router.push({
                id: "@api/channel.partnership.category@show",
                path: "",
              });
            },
          );
        },
      );
    },
  );
}
